export const environment = {
    production: false,
    apiUrl: 'https://apidev.reservas-skinordico.com/'
};
